if (!customElements.get('regularity-hero-banner')) {
  customElements.define(
    'regularity-hero-banner',
    class RegularityHeroBanner extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.lp-hero__button');
        if (!this.btn) return;
        this._onClick = this.handleClick.bind(this);
        this.btn.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        if (this.btn && this._onClick) {
          this.btn.removeEventListener('click', this._onClick);
        }
        this.btn = null;
        this._onClick = null;
      }

      handleClick(event) {
        const href = this.btn.getAttribute('href');

        if (href && href.startsWith('#') && href.length > 1) {
          const target = document.querySelector(href);

          if (target) {
            event.preventDefault();

            const isDesktop = window.innerWidth >= 1024;

            let offset = 0;
            if (isDesktop) {
              const header = document.querySelector('.section-header');
              offset = header ? header.offsetHeight : 0;
            }

            const targetPosition =
              target.getBoundingClientRect().top +
              window.pageYOffset -
              offset;

            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  );
}
